module.exports = __webpack_public_path__ + "img/logo.9f0df7b3.png";